import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { TESTIMONIALS } from "@/constants/testIds";

const quotes = [
  {
    text:
      "They didn't just make me a ring. They listened for a year — and then delivered a piece that felt like it had always existed.",
    name: "Amelia R.",
    context: "Bespoke engagement — 2024",
  },
  {
    text:
      "Three generations of my family have their pieces here. It's the only place I trust with my grandmother's diamonds.",
    name: "Julien L.",
    context: "Restoration & reset — 2023",
  },
  {
    text:
      "Exceptional value doesn't begin to describe it. What you feel is care, patience, and a room full of history.",
    name: "Priya K.",
    context: "Custom pendant — 2025",
  },
];

export default function Testimonials() {
  const [i, setI] = useState(0);
  const q = quotes[i];

  const next = () => setI((v) => (v + 1) % quotes.length);
  const prev = () => setI((v) => (v - 1 + quotes.length) % quotes.length);

  return (
    <section
      data-testid={TESTIMONIALS.section}
      className="relative bg-[#F7F5F2] px-6 md:px-10 py-28 md:py-40 overflow-hidden"
    >
      <div className="flex items-center justify-between mb-16">
        <p className="text-[10px] uppercase tracking-[0.32em] font-sans text-[#1C1C1A]/70">
          Ch. 06 — In their words
        </p>
        <p className="text-[10px] uppercase tracking-[0.32em] font-sans text-[#1C1C1A]/70">
          {String(i + 1).padStart(2, "0")} / {String(quotes.length).padStart(2, "0")}
        </p>
      </div>

      <div className="relative min-h-[280px] md:min-h-[360px] flex items-start">
        <span
          aria-hidden="true"
          className="absolute -top-8 -left-2 md:-top-16 md:-left-4 font-serif text-[220px] md:text-[380px] leading-none text-[#E5D5C1] select-none pointer-events-none"
        >
          &ldquo;
        </span>

        <div className="relative z-10 max-w-4xl mx-auto text-center pt-10">
          <AnimatePresence mode="wait">
            <motion.blockquote
              key={i}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
              className="font-serif italic font-light text-3xl md:text-5xl lg:text-6xl leading-[1.15] tracking-[-0.01em]"
            >
              {q.text}
            </motion.blockquote>
          </AnimatePresence>

          <AnimatePresence mode="wait">
            <motion.div
              key={`${i}-meta`}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.6, delay: 0.15 }}
              className="mt-12 flex flex-col items-center gap-1"
            >
              <span className="font-sans text-sm">{q.name}</span>
              <span className="text-[10px] uppercase tracking-[0.32em] font-sans text-[#1C1C1A]/60">
                {q.context}
              </span>
            </motion.div>
          </AnimatePresence>
        </div>
      </div>

      <div className="mt-16 flex items-center justify-center gap-4">
        <button
          data-testid={TESTIMONIALS.prev}
          onClick={prev}
          className="w-11 h-11 border border-[#1C1C1A] flex items-center justify-center hover:bg-[#1C1C1A] hover:text-[#F7F5F2] transition-colors duration-500"
          aria-label="Previous testimonial"
        >
          ←
        </button>
        <button
          data-testid={TESTIMONIALS.next}
          onClick={next}
          className="w-11 h-11 border border-[#1C1C1A] flex items-center justify-center hover:bg-[#1C1C1A] hover:text-[#F7F5F2] transition-colors duration-500"
          aria-label="Next testimonial"
        >
          →
        </button>
      </div>
    </section>
  );
}
